import { useState } from 'react';
import axios, { AxiosError } from 'axios';

/** FreightSafe's partner token, kept apart from the app's own login token ('jwt'), which these endpoints refuse */
export const FREIGHT_SAFE_TOKEN_KEY = 'freightSafeJwt';

/* Plain axios rather than ApiClient, whose interceptors would put the app's own login token in place of
   FreightSafe's, or try to refresh it */
const useGetFreightSafeAPI = (endpoint: string) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [data, setData] = useState<any>(null);
	const [error, setError] = useState<AxiosError | null>(null);

	const callAPI = async (query: string = '') => {
		setIsLoading(true);
		try {
			const res = await axios.get(`/inertia${endpoint}?${query}`, {
				headers: {
					Accept: 'application/json',
					Authorization: `Bearer ${localStorage.getItem(FREIGHT_SAFE_TOKEN_KEY)}`,
				},
			});
			setData(res.data);
			setError(null);
		} catch (e) {
			setError(e as AxiosError);
		} finally {
			setIsLoading(false);
		}
	};

	return {
		isLoading,
		data,
		error,
		callAPI,
	};
};

export const useGetOptedInFreightSafe = () => useGetFreightSafeAPI('/freight-safe/list');

export const useGetCovered = () => useGetFreightSafeAPI('/freight-safe/covered');
